import { useMemo } from 'react';
import { Select } from '@direct-frontend/components';
import { type OpenApiSchemaCharacteristicGroupWithCharacteristics } from '#shared/api/schema';
import { type CharacteristicGroupSelectProps } from './types';

export type CharacteristicGroupSelectUIProps = CharacteristicGroupSelectProps & {
    groups?: OpenApiSchemaCharacteristicGroupWithCharacteristics[];
};

export const CharacteristicGroupSelectUI = (props: CharacteristicGroupSelectUIProps) => {
    const { value, groups, label, ...rest } = props;
    const items = useMemo(() => {
        if (!groups) {
            return [];
        }

        return groups.map((item) => {
            return {
                value: item.id,
                content: item.title,
            };
        });
    }, [groups]);

    return (
        <Select
            {...rest}
            label={label}
            placeholder="Выберите"
            value={value}
            items={items}
            size="m"
            color="contour"
            matchTriggerWidth
        />
    );
};
